// extracted by mini-css-extract-plugin
module.exports = {"projectContainer":"project-container_projectContainer__32Gre"};